export default __webpack_public_path__ + "static/media/laboral_2.406ed665.jpg";